import { TOPIC_SOURCES, type TopicSource } from './types/contentCommonTypes';

export { TOPIC_SOURCES };

export const TOPIC_SOURCE_CONTRACT_VERSION = 'deepmox-topic-source/v1' as const;

export const PUBLIC_TOPIC_SOURCES = ['public_editorial', 'community_contribution', 'github_trending'] as const satisfies readonly TopicSource[];

export const PUBLIC_TOPIC_SOURCE_SQL = PUBLIC_TOPIC_SOURCES.map((source) => `'${source}'`).join(',');

const TOPIC_SOURCE_SET = new Set<string>(TOPIC_SOURCES);
const PUBLIC_TOPIC_SOURCE_SET = new Set<string>(PUBLIC_TOPIC_SOURCES);

export function parseStoredTopicSource(value: unknown): TopicSource | null {
	return typeof value === 'string' && TOPIC_SOURCE_SET.has(value) ? (value as TopicSource) : null;
}

export function isPublicTopicSource(value: unknown): value is (typeof PUBLIC_TOPIC_SOURCES)[number] {
	return typeof value === 'string' && PUBLIC_TOPIC_SOURCE_SET.has(value);
}

export function isGithubDeepDiveSource(value: unknown): value is 'github_trending' {
	return value === 'github_trending';
}

export function topicSourceFromPipelineSource(value: unknown): TopicSource | null {
	switch (value) {
		case 'manual':
		case 'local_inline':
			return 'public_editorial';
		case 'community_idea':
			return 'community_contribution';
		case 'github_repo':
			return 'github_trending';
		case 'ai_create':
			return 'private_ai';
		default:
			return null;
	}
}
